module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/secondary-borders-active.a9b3f618.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/secondary-borders-active.png
// module id = 2582
// module chunks = 11